import React from 'react'
import { BsInstagram } from 'react-icons/bs'
import { FiMail } from 'react-icons/fi'

export const Footer = () => {
    return (
        <>
            <div className="bg-slate-100 pt-[3vw] text-black">
                <div className='flex flex-wrap justify-center md:gap-[10%] gap-[4vh] mb-[10px]'>
                    <div className='md:w-[35%] w-[90%]'>
                        <h1 className='text-2xl font-bold'>
                            Roots 20<p className='text-rose-600 inline'>23 </p>
                        </h1>
                        <p className='text-lg font-semibold mt-[1vw]'>
                            Just like a tree's strength lies in its roots, our event taps into the essence of creativity. Get ready to be amazed by guest lectures, workshops, and exhibitions by experts. Let's embrace our beginnings and fuel our passions.
                        </p>
                    </div>
                    <div className='md:w-[35%] w-[90%] flex flex-col justify-between'>
                        <div className='w-full flex text-lg font-semibold justify-between'>
                            <div>
                                About us
                                <br />
                                FAQS
                                <br />
                                About Theme
                                <br />
                                SPP
                            </div>
                            <div>
                                WorkShop
                                <br />
                                Events
                                <br />
                                Music
                                <br />
                                Dance
                            </div>
                            <div>
                                Motivation
                                <br />
                                Teams
                                <br />
                                MERCH
                                <br />
                                Photography
                            </div>
                        </div>
                        <div className='md:w-[80%] w-[90%]'>
                            <div className='flex justify-between'>
                                <div className='flex gap-[25px] items-center'>
                                    <p className='text-center font-bold'>Connect with Us: </p>
                                    <a href='https://www.instagram.com/rootsnitrkl/' target='_blank' rel="noreferrer">
                                        <BsInstagram size={30} />

                                    </a>
                                    <a href='mailto:roots.nitrkl@gmail.com' target='_blank' rel="noreferrer">
                                        <FiMail size={30} />
                                    </a>

                                </div>
                            </div>

                        </div>
                    </div>
                    <hr className='border-[2px] border-black md:w-[80%] w-[90%] mb-[10px] mt-[4vh]' />


                    <p className='font-semibold'> ©Roots 2023. All rights reserved. </p>
                </div>

            </div >
        </>
    )
}
